(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diald-charcoal-explore"] && !Shopify.designMode) return;
  try {
    
function dialdRailInit(scope){scope.querySelectorAll('.dc-rail:not([data-ready])').forEach(root=>{root.dataset.ready='true';const rail=root.querySelector('.dc-rail__track');const controls=root.querySelector('.dc-rail__controls');controls.hidden=false;const buttons=[...controls.querySelectorAll('button')];function update(){buttons[0].disabled=rail.scrollLeft<4;buttons[1].disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;}buttons.forEach(button=>button.addEventListener('click',()=>{const card=rail.querySelector('.dc-rail__card');rail.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+22),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();});}dialdRailInit(document);document.addEventListener('shopify:section:load',event=>dialdRailInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diald-corporate-lab"] && !Shopify.designMode) return;
  try {
    
function dialdCompareInit(scope){scope.querySelectorAll('.cp-compare:not([data-ready])').forEach(root=>{root.dataset.ready='true';const range=root.querySelector('input[type="range"]');const update=()=>{root.style.setProperty('--cp-reveal',range.value+'%');range.setAttribute('aria-valuetext',range.value+'%');};range.addEventListener('input',update);update();});}dialdCompareInit(document);document.addEventListener('shopify:section:load',event=>dialdCompareInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diald-scroll-assembly"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('diald-scroll-assembly-controller')){
class DialdAssemblyController extends HTMLElement{}
customElements.define('diald-scroll-assembly-controller',DialdAssemblyController);
const instances=new Map();
const clamp=value=>Math.max(0,Math.min(1,value));
const ease=value=>value*value*(3-2*value);
function init(root){
 if(instances.has(root))return;
 const parts=[...root.querySelectorAll('[data-part]')],range=root.querySelector('[data-scrub]'),label=root.querySelector('[data-phase]'),number=root.querySelector('[data-phase-number]'),percent=root.querySelector('[data-percent]');
 const copy=JSON.parse(root.querySelector('[data-assembly-copy]').textContent),motion=matchMedia('(prefers-reduced-motion: reduce)');
 const vectors=[[-.20,.20,-18],[-.25,.02,-12],[.18,.34,12],[.05,-.06,9],[.27,-.35,15],[.12,.04,6]];const scales=[1,.75,.75,.72,.75,.36];const centers=[[.016,.035],[.012,.071],[-.018,.067],[.020,-.002],[.004,0],[.010,0]];
 let frame=0,active=true,manual=false,last=-1;
 const draw=p=>{p=clamp(p);if(Math.abs(p-last)<.0001)return;last=p;const assembled=p<.5?ease(clamp((p-.08)/.34)):1-ease(clamp((p-.60)/.32));const separation=1-assembled;
 parts.forEach((part,i)=>{const [x,y,rot]=vectors[i];const [cx,cy]=centers[i];part.style.transform=`translate(${(x*separation+(i===5?.42:0)-cx*scales[i])*100}%,${(y*separation-cy*scales[i])*100}%) rotate(${rot*separation}deg) scale(${scales[i]})`;part.style.opacity=i===5?Math.min(1,separation*4):1;});
 const phase=p<.36?0:p<.64?1:2;label.textContent=[copy.phases,copy.middle,copy.end][phase];number.textContent=`0${phase+1}`;range.value=Math.round(p*100);percent.textContent=`${Math.round(p*100)}%`;root.dataset.progress=p.toFixed(4);root.dataset.assembled=assembled.toFixed(4);};
 const update=()=>{frame=0;if(!active||motion.matches||manual)return;const rect=root.getBoundingClientRect();const length=root.offsetHeight-root.querySelector('.da-assembly__sticky').offsetHeight;draw(length>0?-rect.top/length:0);};
 const request=()=>{if(!frame)frame=requestAnimationFrame(update);};
 const scroll=()=>{manual=false;request();};
 const resize=()=>{last=-1;request();};
 const input=()=>{manual=true;draw(Number(range.value)/100);};
 const preference=()=>{root.toggleAttribute('data-reduced',motion.matches);manual=false;last=-1;motion.matches?draw(.5):request();};
 const observer=new IntersectionObserver(entries=>{active=entries[0].isIntersecting;if(active)request();},{rootMargin:'200px'});observer.observe(root);
 addEventListener('scroll',scroll,{passive:true});addEventListener('resize',resize,{passive:true});range.addEventListener('input',input);motion.addEventListener('change',preference);preference();draw(motion.matches?.5:0);
 const image=new Image();image.onload=()=>{root.dataset.ready='true';delete root.dataset.error;};image.onerror=()=>{root.dataset.error='true';};image.src=root.dataset.atlasSrc;
 instances.set(root,()=>{observer.disconnect();removeEventListener('scroll',scroll);removeEventListener('resize',resize);range.removeEventListener('input',input);motion.removeEventListener('change',preference);cancelAnimationFrame(frame);instances.delete(root);});
}
const scan=scope=>scope.querySelectorAll('[data-diald-assembly]').forEach(init);
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});}else{scan(document);}document.addEventListener('shopify:section:load',event=>scan(event.target));document.addEventListener('shopify:section:unload',event=>{for(const [root,cleanup]of instances)if(event.target.contains(root))cleanup();});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
